import { containerScroll, sendMessage } from '@composables/useWindowEvents.js'
import { createRouter, createWebHashHistory } from 'vue-router'
import { MOD_BROWSE_ROUTE } from '@config/routeNames.js'
import { handleScroll } from '@helpers/utils.js'
import routes from '@router/allRoutes.js'
import { authStore } from '@stores'
import { nextTick, ref } from 'vue'

export const profileFrom = ref(undefined)

const savedScrollPositions = new Map()
const { isLoggedIn } = authStore()

const router = new createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: (to, from, savedPos) => {
    const key = from.fullPath + '|' + to.fullPath
    // If used browser back button, scroll to saved postiion
    if (savedPos && savedScrollPositions.has(key)) {
      nextTick(() => {
        sendMessage({ modioScroll: savedScrollPositions.get(key) })
        savedScrollPositions.delete(key)
      })
    } else {
      if (from.name?.includes('browse') || from.name?.includes('library')) {
        if (to.name?.includes('browse')) return
        if (to.name?.includes('library')) return
      }
      if (containerScroll.value.frameTop < -100) {
        handleScroll(to, from)
      }
    }
  },
})

router.beforeEach((to) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn.value) {
      return { name: MOD_BROWSE_ROUTE }
    }
  }
})

router.afterEach((to, from) => {
  // used to ensure back button on UserView returns out of user profile
  if (to.path.includes('/u/') && !from.path.includes('/u/')) {
    profileFrom.value = from
  }

  savedScrollPositions.set(
    to.fullPath + '|' + from.fullPath,
    containerScroll.value.scrollY || 0
  )
  sendMessage({ modioPage: to.fullPath })
})

export default router
